module.exports = __webpack_public_path__ + "static/img/汉口银行.302afea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/汉口银行.png
// module id = HjOR
// module chunks = 18